<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refBatchSalesClosedListGrid'
        :data-source='batchSalesClosedList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :auto-navigate-to-focused-row="false"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="판매가"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          :allowEditing='false'
          caption="고객사"
          data-field="고객사코드"
          sort-order="asc"
        >
          <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="차종"
          data-field="차종"
          sort-order="asc"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="납입품번"
          data-field="납입품번"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
          width="200"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="매출수량"
          data-field="매출수량"
          format='#,##0'
          dataType="number"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="매출금액"
          data-field="매출금액"
          format='#,##0'
          dataType="number"
          :visible='true'
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="품번"
            display-format="{0} (건)"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="매출수량"
            display-format="{0}"
          />
          <DxTotalItem
            value-format='#,##0'
            summary-type="sum"
            column="매출금액"
            display-format="{0} (원)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
      <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel,
  DxLookup } from 'devextreme-vue/data-grid'
// import AppLib from '../../share/AppLib'
import ExcelJS from 'exceljs'
import AppLib from '../../share/AppLib'

export default {
  name: 'salesClosed',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '월별매출마감관리'
        }
      ],
      batchSalesClosedList: [],
      salesClosedRegDateBox: null,
      salesClosedDate: null,
      customerLookup: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.customerLookup = this.$store.getters.getCustomerInfo
    this.salesClosedDate = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`
    this.refreshSalesClosed()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    batchInserted () {
      this.$_sp.runDeleteSqlProc('월별매출마감', [{ 마감일자: this.salesClosedDate }])
        .then(() => {
          this.$_sp.runInsertSqlProc('월별매출마감', null, this.batchSalesClosedList)
            .then(() => {
              this.isLoading = false
              this.$snotify.info('등록 되었습니다.')
            })
            .catch(error => {
              this.isLoading = false
              if (error.response.status === ConstDef.GENERRAL_ERROR) {
                this.$snotify.error(error.response.data.message)
              } else {
                this.$snotify.error(`에러코드 : ${error.response.status}`)
              }
            })
        })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>매출마감 등록</b></div>`
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준월:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.salesClosedDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy-MM',
            onInitialized: (args) => {
              this.salesClosedRegDateBox = args.component
            },
            onValueChanged: (args) => {
              this.salesClosedDate = args.value
              this.refreshSalesClosed(this.salesClosedDate)
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'file',
            text: '파일선택',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        }
      )
    },
    onDetailFileChange ($event) {
      this.$snotify.confirm('해당월에 이미 데이터가 존재할시 새로운 파일 내용으로 덮어씌워집니다.', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '업로드',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.onDetailFileRead($event)
            }
          },
          { text: '취소',
            action: (toast) => { this.$snotify.remove(toast.id) }
          }
        ]
      })
    },
    onDetailFileRead ($event) {
      this.isLoading = true
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      this.batchSalesClosedList = []
      let vm = this
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()

      reader.onloadend = function (event) {
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          workbook.eachSheet(function (worksheet, sheetId) {
            console.log('start eachSheet')
            if (worksheet.name !== '차종사양' && worksheet.name !== '생산계획' && worksheet.name !== '사양표' && worksheet.name !== '대수' && worksheet.name !== '제품가격' && worksheet.name.indexOf('Sheet') < 0) {
              vm.saveCarMap(worksheet, worksheet.name)
            }
          })
        })
          .then(function () {
            vm.batchInserted()
          })
      }
      reader.readAsArrayBuffer(file)
    },
    saveCarMap (worksheet, company) {
      let row = null
      let value = null
      let dataJson = {}
      let emptyRow = 0
      for (let i = 8; i < 3000; i++) {
        row = worksheet.getRow(i)
        value = AppLib.getCellFromExcel(row, 2)
        if (value !== null && (value.indexOf('T O T A L') >= 0 || value.indexOf('TOTAL') >= 0)) continue
        if (value === null || value === '소급정산') {
          if (emptyRow === 0) {
            emptyRow++
            continue
          } else {
            console.log(`${company}  read row=${i - 8}`)
            break
          }
        }
        emptyRow = 0
        dataJson.고객사코드 = company
        dataJson.차종 = AppLib.getCellFromExcel(row, 2)
        dataJson.납입품번 = AppLib.getCellFromExcel(row, 3)
        dataJson.품번 = AppLib.getCellFromExcel(row, 4)
        dataJson.품명 = AppLib.getCellFromExcel(row, 5)
        dataJson.매출수량 = AppLib.getCellFromExcel(row, 10)
        dataJson.매출금액 = AppLib.getCellFromExcel(row, 14)
        let temp = {
          마감일자: this.salesClosedDate,
          고객사코드: this.$_.findWhere(this.customerLookup, { 거래처명: company }).거래처코드,
          차종: dataJson.차종,
          납입품번: dataJson.납입품번,
          품번: dataJson.품번,
          품명: dataJson.품명,
          매출수량: dataJson.매출수량,
          매출금액: dataJson.매출금액
        }
        if (dataJson.매출금액 > 0) {
          this.batchSalesClosedList.push(temp)
        }
      }
    },
    refreshSalesClosed () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindSqlProc('월별매출마감', { 마감일자: this.salesClosedDate })
        .then((data) => {
          this.batchSalesClosedList = this.$_sp.MakeModel(data)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
